import {selector} from "recoil";
import {userKakaoScopeState, userState} from "./userAtom";

export const authenticationStatusSelector = selector<boolean>({
    key: 'authenticationStatusSelector',
    get: ({ get }) => {
        const user = get(userState);
        return user !== null;
    },
})

/**
 * 카카오 메시지 전송을 위해 필요한 동의 항목들 중 동의하지 않은 항목들을 반환하는 selector
 * @returns 동의하지 않은 항목들의 id 배열(ex: 'friends', 'talk_message')
 */
export const sendKakaoMessageNotAgreedScopesSelector = selector<string[]>({
    key: 'sendKakaoMessageNotAgreedScopesSelector',
    get: ({ get }) => {
        const scopes = get(userKakaoScopeState);
        const requiredScopeIds = ['friends', 'talk_message'];
        let notAgreedScopes: string[] = [];
        for (let scopeId of requiredScopeIds) {
            const scope = scopes.find(scope => scope.id === scopeId);
            if (!scope?.agreed) {
                notAgreedScopes.push(scopeId);
            }
        }

        return notAgreedScopes
    },
})